// HKDSE 2017 Paper 1 Knowledge Graph Samples - Complete Set Part 2
// Continuing with remaining questions from the LaTeX file

export const hkdse2017Samples_complete_part2 = {
  functions: [
    {
      id: 'hkdse2017_functions_01',
      problem: "It is known that $y$ varies inversely as $\\sqrt{x}$. When $x = 144$, $y = 81$. (a) Express $y$ in terms of $x$. (b) If the value of $x$ increases from $144$ to $324$, find the change in the value of $y$.",
      problemType: "functions_inverse_variation",
      difficulty: "intermediate",
      description: "Solving problems with inverse variation functions",
      graphData: {
        nodes: [
          {
            id: "inverse_variation",
            name: "Inverse Variation",
            type: "concepts",
            description: "Understanding inverse variation",
            value: "y varies inversely as √x: y = k/√x",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "given_condition",
            name: "Given Condition",
            type: "concepts",
            description: "When x = 144, y = 81",
            value: "Substitute to find constant k",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "step1_find_constant",
            name: "Step 1: Find Constant k",
            type: "steps",
            description: "Substitute given values",
            value: "81 = k/√144 = k/12",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step2_solve_for_k",
            name: "Step 2: Solve for k",
            type: "steps",
            description: "Calculate the constant",
            value: "k = 81 × 12 = 972",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_a_final_function",
            name: "Part (a): Final Function",
            type: "steps",
            description: "Write the function",
            value: "y = 972/√x",
            importance: 10,
            x: 0, y: 100, z: -15
          },
          {
            id: "part_b_find_y1",
            name: "Part (b): Find y₁",
            type: "steps",
            description: "Find y when x = 144",
            value: "y₁ = 972/√144 = 972/12 = 81",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_find_y2",
            name: "Part (b): Find y₂",
            type: "steps",
            description: "Find y when x = 324",
            value: "y₂ = 972/√324 = 972/18 = 54",
            importance: 8,
            x: 0, y: 300, z: 0
          },
          {
            id: "part_b_find_change",
            name: "Part (b): Find Change",
            type: "steps",
            description: "Calculate change in y",
            value: "Change = y₂ - y₁ = 54 - 81 = -27",
            importance: 9,
            x: 0, y: 400, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) y = 972/√x (b) -27",
            importance: 10,
            x: 0, y: 500, z: 0
          }
        ],
        links: [
          { from: "inverse_variation", to: "step1_find_constant", type: "enables", strength: 9 },
          { from: "given_condition", to: "step1_find_constant", type: "enables", strength: 9 },
          { from: "step1_find_constant", to: "step2_solve_for_k", type: "leads to", strength: 9 },
          { from: "step2_solve_for_k", to: "part_a_final_function", type: "leads to", strength: 10 },
          { from: "part_a_final_function", to: "part_b_find_y1", type: "enables", strength: 8 },
          { from: "part_a_final_function", to: "part_b_find_y2", type: "enables", strength: 8 },
          { from: "part_b_find_y1", to: "part_b_find_change", type: "enables", strength: 9 },
          { from: "part_b_find_y2", to: "part_b_find_change", type: "enables", strength: 9 },
          { from: "part_a_final_function", to: "final_answer", type: "contributes to", strength: 10 },
          { from: "part_b_find_change", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  mensuration: [
    {
      id: 'hkdse2017_mensuration_01',
      problem: "If the capacity of a bottle can be measured as $200$ mL accurate to the nearest $10$ mL, it is called standard. (a) Find the minimum possible capacity of a standard bottle. (b) Someone claims that the total capacity of $120$ standard bottles can be measured as $23.3$ L accurate to the nearest $0.1$ L. Do you agree? Explain your answer.",
      problemType: "mensuration_accuracy",
      difficulty: "intermediate",
      description: "Working with accuracy and significant figures",
      graphData: {
        nodes: [
          {
            id: "accuracy_concept",
            name: "Accuracy Concept",
            type: "concepts",
            description: "Understanding accuracy to nearest unit",
            value: "200 mL ± 5 mL",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "range_calculation",
            name: "Range Calculation",
            type: "concepts",
            description: "Finding range of possible values",
            value: "Range = 195 mL to 205 mL",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "part_a_minimum_capacity",
            name: "Part (a): Minimum Capacity",
            type: "steps",
            description: "Find minimum possible capacity",
            value: "Minimum = 200 - 5 = 195 mL",
            importance: 10,
            x: 150, y: -100, z: 20
          },
          {
            id: "part_b_total_range",
            name: "Part (b): Total Range",
            type: "steps",
            description: "Find range for 120 bottles",
            value: "Total range = 120 × 195 to 120 × 205",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_b_calculation",
            name: "Part (b): Calculation",
            type: "steps",
            description: "Calculate total range",
            value: "Total = 23,400 mL to 24,600 mL",
            importance: 8,
            x: 0, y: 100, z: -15
          },
          {
            id: "part_b_convert_to_liters",
            name: "Part (b): Convert to Liters",
            type: "steps",
            description: "Convert to liters",
            value: "Total = 23.4 L to 24.6 L",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_check_claim",
            name: "Part (b): Check Claim",
            type: "steps",
            description: "Check if 23.3 L is possible",
            value: "23.3 L is within range ✓",
            importance: 9,
            x: 0, y: 300, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) 195 mL (b) Yes, agree (23.3 L is within possible range)",
            importance: 10,
            x: 0, y: 400, z: 0
          }
        ],
        links: [
          { from: "accuracy_concept", to: "range_calculation", type: "enables", strength: 9 },
          { from: "range_calculation", to: "part_a_minimum_capacity", type: "enables", strength: 10 },
          { from: "part_a_minimum_capacity", to: "part_b_total_range", type: "enables", strength: 8 },
          { from: "part_b_total_range", to: "part_b_calculation", type: "leads to", strength: 8 },
          { from: "part_b_calculation", to: "part_b_convert_to_liters", type: "leads to", strength: 8 },
          { from: "part_b_convert_to_liters", to: "part_b_check_claim", type: "leads to", strength: 9 },
          { from: "part_a_minimum_capacity", to: "final_answer", type: "contributes to", strength: 10 },
          { from: "part_b_check_claim", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  geometry_advanced: [
    {
      id: 'hkdse2017_geometry_advanced_01',
      problem: "In Figure 1, $OPQR$ is a rhombus such that $OP = OQ = OR$. $OQ$ and $PR$ intersect at point $S$. $S$ is the midpoint of $PR$. (a) Prove that $\\triangle OPS \\cong \\triangle ORS$. (b) It is known that $O$ is the center of the circle passing through $P$, $Q$ and $R$. If $OQ = 6$ cm and $\\angle PRQ = 10°$, find the area of rhombus $OPQR$. Express the answer in terms of $\\pi$.",
      problemType: "geometry_rhombus_circle",
      difficulty: "intermediate",
      description: "Working with rhombus and circle properties",
      graphData: {
        nodes: [
          {
            id: "rhombus_properties",
            name: "Rhombus Properties",
            type: "concepts",
            description: "All sides equal, diagonals perpendicular",
            value: "OP = OQ = OR = PQ = QR = RP",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "midpoint_property",
            name: "Midpoint Property",
            type: "concepts",
            description: "S is midpoint of PR",
            value: "PS = SR",
            importance: 8,
            x: 0, y: -200, z: 0
          },
          {
            id: "part_a_congruent_triangles",
            name: "Part (a): Congruent Triangles",
            type: "steps",
            description: "Prove △OPS ≅ △ORS",
            value: "SSS: OP = OR, PS = SR, OS = OS",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "part_b_circle_properties",
            name: "Part (b): Circle Properties",
            type: "steps",
            description: "O is center of circle through P, Q, R",
            value: "OP = OQ = OR = radius",
            importance: 8,
            x: -200, y: 0, z: 25
          },
          {
            id: "part_b_find_angle",
            name: "Part (b): Find Angle",
            type: "steps",
            description: "Use given angle PRQ = 10°",
            value: "∠PRQ = 10°",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_b_calculate_area",
            name: "Part (b): Calculate Area",
            type: "steps",
            description: "Find area of rhombus",
            value: "Area = ½ × diagonal₁ × diagonal₂",
            importance: 8,
            x: 200, y: 0, z: 25
          },
          {
            id: "part_b_final_calculation",
            name: "Part (b): Final Calculation",
            type: "steps",
            description: "Calculate area in terms of π",
            value: "Area = 36π cm²",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) △OPS ≅ △ORS by SSS (b) 36π cm²",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "rhombus_properties", to: "part_a_congruent_triangles", type: "enables", strength: 9 },
          { from: "midpoint_property", to: "part_a_congruent_triangles", type: "enables", strength: 8 },
          { from: "part_a_congruent_triangles", to: "part_b_circle_properties", type: "enables", strength: 8 },
          { from: "part_b_circle_properties", to: "part_b_find_angle", type: "enables", strength: 8 },
          { from: "part_b_find_angle", to: "part_b_calculate_area", type: "enables", strength: 8 },
          { from: "part_b_calculate_area", to: "part_b_final_calculation", type: "leads to", strength: 9 },
          { from: "part_a_congruent_triangles", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_final_calculation", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  statistics_advanced: [
    {
      id: 'hkdse2017_statistics_advanced_01',
      problem: "The following stem-and-leaf diagram shows the distribution of wages (in dollars) of a group of workers. Stem-and-leaf table description: Stem (tens digit) represents tens place, Leaf (units digit) represents units place Row 1: Stem 6, Leaves: 1 1 1 3 4 6 8 9 9 Row 2: Stem 7, Leaves: a 7 7 8 Row 3: Stem 8, Leaves: 1 b It is known that the mean and range of the above distribution are $\\$70$ and $\\$22$ respectively. (a) Find the median and standard deviation of the above distribution. (b) If a worker is randomly selected from the group, find the probability that the selected worker's wage exceeds $\\$70$.",
      problemType: "statistics_stem_leaf",
      difficulty: "intermediate",
      description: "Working with stem-and-leaf diagrams and statistics",
      graphData: {
        nodes: [
          {
            id: "stem_leaf_diagram",
            name: "Stem-and-Leaf Diagram",
            type: "concepts",
            description: "Understanding stem-and-leaf representation",
            value: "Data: 61,61,61,63,64,66,68,69,69,7a,77,77,78,81,8b",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "mean_range",
            name: "Mean and Range",
            type: "concepts",
            description: "Given mean = $70, range = $22",
            value: "Use to find missing values a and b",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "step1_find_missing_values",
            name: "Step 1: Find Missing Values",
            type: "steps",
            description: "Find a and b using mean and range",
            value: "a = 0, b = 3",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step2_list_data",
            name: "Step 2: List Data",
            type: "steps",
            description: "List all data points",
            value: "61,61,61,63,64,66,68,69,69,70,77,77,78,81,83",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_a_find_median",
            name: "Part (a): Find Median",
            type: "steps",
            description: "Find median of data",
            value: "Median = 69",
            importance: 8,
            x: -200, y: 100, z: -15
          },
          {
            id: "part_a_find_standard_deviation",
            name: "Part (a): Find Standard Deviation",
            type: "steps",
            description: "Calculate standard deviation",
            value: "σ = √(Σ(x-μ)²/n)",
            importance: 8,
            x: 200, y: 100, z: -15
          },
          {
            id: "part_a_calculation",
            name: "Part (a): Calculation",
            type: "steps",
            description: "Calculate standard deviation",
            value: "σ ≈ 7.2",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_probability",
            name: "Part (b): Probability",
            type: "steps",
            description: "Find P(wage > $70)",
            value: "Count values > 70, divide by total",
            importance: 8,
            x: 0, y: 300, z: 0
          },
          {
            id: "part_b_calculation",
            name: "Part (b): Calculation",
            type: "steps",
            description: "Calculate probability",
            value: "P(wage > $70) = 6/15 = 0.4",
            importance: 8,
            x: 0, y: 400, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) Median = $69, σ ≈ 7.2 (b) 0.4",
            importance: 10,
            x: 0, y: 500, z: 0
          }
        ],
        links: [
          { from: "stem_leaf_diagram", to: "step1_find_missing_values", type: "enables", strength: 9 },
          { from: "mean_range", to: "step1_find_missing_values", type: "enables", strength: 9 },
          { from: "step1_find_missing_values", to: "step2_list_data", type: "leads to", strength: 8 },
          { from: "step2_list_data", to: "part_a_find_median", type: "enables", strength: 8 },
          { from: "step2_list_data", to: "part_a_find_standard_deviation", type: "enables", strength: 8 },
          { from: "part_a_find_median", to: "part_a_calculation", type: "contributes to", strength: 8 },
          { from: "part_a_find_standard_deviation", to: "part_a_calculation", type: "contributes to", strength: 8 },
          { from: "step2_list_data", to: "part_b_probability", type: "enables", strength: 8 },
          { from: "part_b_probability", to: "part_b_calculation", type: "leads to", strength: 8 },
          { from: "part_a_calculation", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_b_calculation", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ]
}; 